import { Controller } from "@hotwired/stimulus"

// Fills the example briefing email with the buyer's REAL picks as they choose them,
// so the preview reflects their actual market. Reads the active (checked + enabled,
// i.e. tracked) company names from the watchlist form and drops them into the
// email's company slots, falling back to generic phrasing per slot when there
// aren't enough picks — and doing nothing on pages without the form (e.g. the
// public /preview map), where the static defaults stand.
export default class extends Controller {
  static targets = ["companyA", "companyB", "companyC"]

  connect() {
    this.form = document.querySelector('form[action*="watchlist"]') || this.element.closest("form")
    if (!this.form) return

    this.onChange = () => this.render()
    this.form.addEventListener("change", this.onChange)
    const list = this.form.querySelector('[data-watchlist-add-target="list"]')
    if (list) {
      this.observer = new MutationObserver(this.onChange)
      this.observer.observe(list, { childList: true, subtree: true })
    }
    this.render()
  }

  disconnect() {
    this.form?.removeEventListener("change", this.onChange)
    this.observer?.disconnect()
  }

  render() {
    const names = this.pickedNames()
    this.fill(this.companyATargets, names[0])
    this.fill(this.companyBTargets, names[1])
    this.fill(this.companyCTargets, names[2])
  }

  // Swap in a real name; restore the slot's generic default when there's no pick.
  fill(targets, name) {
    targets.forEach((el) => {
      el.dataset.default ??= el.textContent
      el.textContent = name || el.dataset.default
    })
  }

  // Names of the companies that would actually be tracked, in briefing order:
  // discovered competitors first, then hand-typed ones, then the own company.
  // Excludes greyed-out (disabled) picks — those aren't tracked on the current plan.
  pickedNames() {
    const names = []
    this.form.querySelectorAll('input[name="competitor_domains[]"]:checked:not(:disabled)').forEach((cb) => {
      names.push(cb.closest("label")?.querySelector(".font-medium")?.textContent)
    })
    this.form.querySelectorAll('[data-watchlist-add-target="list"] [data-label]').forEach((el) => {
      names.push(el.textContent)
    })
    const own = this.form.querySelector('input[name="track_own"]')
    if (own?.checked) names.push(own.closest("label")?.querySelector(".font-medium")?.textContent)

    return [...new Set(names.map((n) => n?.trim()).filter(Boolean))]
  }
}
